
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-cookies",
      function () {
        return require("private-next-pages/politica-cookies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politica-cookies"])
      });
    }
  